export default __webpack_public_path__ + "assets/front/scss/editorial.5e7351798d6a92f9d053b456c9a7a402.css";